(function ($) {
    'use strict';

    $(document).ready(function () {
        const $grid = $('#property-grid');
        const $loadMoreBtn = $('.load-more-btn');
        const $sortSelect = $('.sort-select');
        let currentPage = 1;

        if (!$grid.length || !$loadMoreBtn.length) return;

        function loadProperties(isAppend = true) {
            const sortValue = $sortSelect.val() || 'newest';

            if (!isAppend) {
                currentPage = 1;
                $grid.css('opacity', '0.5'); // Visual feedback
            }

            const data = {
                action: 'load_more_properties',
                page: isAppend ? currentPage + 1 : 1,
                sort: sortValue,
                nonce: reim_ajax.nonce || reim_ajax.reim_ajax_nonce // Handle both localizations if inconsistent
            };

            $.ajax({
                url: reim_ajax.ajaxurl || reim_ajax.ajax_url,
                type: 'POST',
                data: data,
                beforeSend: function () {
                    $loadMoreBtn.text('Loading...');
                    $loadMoreBtn.prop('disabled', true);
                },
                success: function (response) {
                    if (response.success) {
                        if (isAppend) {
                            $grid.append(response.data.html);
                            currentPage++;
                            $loadMoreBtn.data('current-page', currentPage);
                        } else {
                            $grid.html(response.data.html);
                            $grid.css('opacity', '1');
                            currentPage = 1;
                            $loadMoreBtn.data('current-page', 1);
                        }

                        const maxPages = response.data.max_page || $loadMoreBtn.data('max-pages');

                        if (currentPage >= maxPages) {
                            $loadMoreBtn.hide();
                        } else {
                            $loadMoreBtn.show();
                            $loadMoreBtn.text('Load More');
                            $loadMoreBtn.prop('disabled', false);
                        }
                    } else {
                        if (!isAppend) $grid.html('<p class="text-center">No properties found.</p>');
                        $loadMoreBtn.hide();
                    }
                },
                error: function () {
                    console.error('AJAX error loading properties');
                    $loadMoreBtn.text('Load More');
                    $loadMoreBtn.prop('disabled', false);
                }
            });
        }

        $loadMoreBtn.on('click', function (e) {
            e.preventDefault();
            loadProperties(true);
        });

        $sortSelect.on('change', function () {
            loadProperties(false);
        });
    });

})(jQuery);
